import React, { Component, Fragment } from "react";
import { Form, FormGroup, Button, Modal, Badge, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from "reactstrap";

import { injectIntl } from "react-intl";
import { Alert, Cascader, Select, InputNumber, Input } from "antd";

import { connect } from "react-redux";
import IntlMessages from "../../helpers/IntlMessages";

import { getRequestRestaurant, createAlacarteRequest, updateRestaurantConfig, getSeatsAndSlotsRestaurant } from "../../redux/alacarte/actions";

const { Option } = Select;
const { TextArea } = Input;

class AlacarteCreateRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showIcon: false,
      time: "",
      monday_open: "",
      monday_close: "",
      open_time: "",
      attributeForm: [],
      daysForAlacarte: ["mondays", "tuesdays", "wednesdays", "thursdays", "fridays", "saturdays", "sundays"],
      time_slots: {},
      config: {},
      updateAndCreateButtonStatus: false,
      configProps: null,
      guestCancelReservationTime: "",
      stopReservationBefore: "",
      maxGuestCount: "",
      guestOneResEachDay: false,
      guestOneResPerRestaurant: false,
      mainCourseRequired: false,

      formView: false,
      options: [],
      optionsProps: [],
      forms: [],
      peopleCount: 1,
      childrenCount: 0,
      selectedOptions: "",
      disabledButton: {
        selectedOptions: false,
        peopleCount: false
      },
      valid: false,
      createRequest: false,
      showInputNameAndRoomsLength: false,
      showFormPeopleAndTimeSlotRequired: false
    };
  }

  static getDerivedStateFromProps({ getReservationOptions }) {
    return {
      optionsProps: getReservationOptions
    };
  }

  createForm = () => {
    const forms = [];
    const childCount = Number(this.state.childrenCount);
    const peopleCount = Number(this.state.peopleCount);
    for (let i = 0; i < peopleCount; i++) {
      forms.push({
        // id: i,
        name: "",
        room_number: "",
        main_course_id: "",
        main_course_name: "",
        is_children: false,
        notes: ""
      });
    }
    if (childCount && childCount !== 0) {
      for (let j = 0; j < childCount; j++) {
        forms.push({
          //   id: this.state.peopleCount + i,
          name: "",
          room_number: "",
          main_course_id: "",
          main_course_name: "",
          is_children: true
        });
      }
    }
    if (
      peopleCount <= 10 &&
      peopleCount !== 0 &&
      peopleCount !== "" &&
      this.state.selectedOptions.length > 1 &&
      childCount <= 10 &&
      childCount !== ""
    ) {
      this.setState({
        formView: true,
        forms
      });
    } else {
      this.setState({
        showFormPeopleAndTimeSlotRequired: true
      });
      setTimeout(() => {
        this.setState({
          showFormPeopleAndTimeSlotRequired: false
        });
      }, 3000);
    }
  };

  createRequest = (hotel_id, forms) => {
    const custom_fields_values = [
      {
        id: "211",
        value: JSON.stringify({
          restaurant_id: this.state.selectedOptions[0].value,
          restaurant_name: this.state.selectedOptions[0].label,
          restaurant_time_slot: this.state.selectedOptions[1].label,
          timezone_id: this.props.alacarteApp.getSeatsAndSlots[this.state.selectedOptions[0].value].timezone_id
        })
      },
      {
        id: "212",
        value: JSON.stringify({ people_count: this.state.peopleCount, children_count: this.state.childrenCount })
      },
      {
        id: "213",
        value: JSON.stringify(forms)
      }
    ];

    const body = {};
    body.custom_fields_values = custom_fields_values;
    body.service_type = "ALACARTE_RESTAURANT_RESERVATION";
    body.service_id = "351";
    body.hotel_id = String(hotel_id);
    body.is_staff = "true";
    body.restaurant_id = this.state.selectedOptions[0].value;
    body.restaurant_name = this.state.selectedOptions[0].label;
    body.reservation_id = this.state.selectedOptions[1].value;
    body.reservation_status = "RESERVED";
    body.requester_id = this.props.authData.username;
    body.due_at = this.state.selectedOptions[1].date;

    const names = forms.map(res => res.name);
    const rooms = forms.map(res => res.room_number);
    const emptyInputName = names.filter(res => res === "");
    const emptyInputRoom = rooms.filter(res => res === "");

    if (emptyInputName.length === 0 && emptyInputRoom.length === 0) {
      this.props.createAlacarteRequest(body);
      this.setState({
        formView: true,
        createRequest: true
      });
    } else {
      this.setState({
        showInputNameAndRoomsLength: true
      });
      setTimeout(() => {
        this.setState({
          showInputNameAndRoomsLength: false
        });
      }, 3000);
    }
  };

  changeCancelAndToggleOff = () => {
    this.props.toggle();
    this.setState({
      formView: false,
      peopleCount: 1,
      childrenCount: 0,
      disabledButton: {
        selectedOptions: false,
        peopleCount: false
      },
      selectedOptions: "",
      createRequest: false,
      showInputNameAndRoomsLength: false,
      showFormPeopleAndTimeSlotRequired: false
    });
  };

  handleChangeChildCount = e => {
    if (this.state.selectedOptions && this.state.selectedOptions.length === 2) {
      if (e <= this.state.selectedOptions[1].available_seats) {
        this.setState({
          childrenCount: e
        });
      }
    }
  };

  handleChangePeopleCount = e => {
    if (this.state.selectedOptions && this.state.selectedOptions.length === 2) {
      if (e <= this.state.selectedOptions[1].available_seats && e !== 0) {
        this.setState({
          peopleCount: e
        });
      }
    }
  };

  handleChangeMainCourse = (value, index, name) => {
    const indexOfForms = this.state.forms[index];
    indexOfForms.main_course_id = value;
    indexOfForms.main_course_name = name.props.name;
    this.setState({
      ...this.state.forms
    });
  };

  handleChangeForms = (e, index) => {
    const indexOfForms = this.state.forms[index];
    indexOfForms[e.target.name] = e.target.value;
    this.setState({
      ...this.state.forms
    });
  };

  createStateOptions = () => {
    this.setState({
      options: this.props.alacarteApp.getReservationOptions
    });
  };

  onChange = (value, selectedOptions) => {
    this.setState({
      selectedOptions
    });
  };

  loadData = async selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    const payload = {
      hotel_id: this.props.hotelConfig.hotelId,
      restaurant_id: targetOption.value
    };
    const selectValue = targetOption.value;

    await this.props.getSeatsAndSlotsRestaurant(payload);
    setTimeout(() => {
      if (Object.keys(this.props.alacarteApp.getSeatsAndSlots).length > 0 && this.props.alacarteApp.getSeatsAndSlots[selectValue]) {
        targetOption.loading = false;
        const valueMap = this.props.alacarteApp.getSeatsAndSlots[selectValue].listOfReservationSlots;
        targetOption.children = valueMap.map(res => {
          return {
            label: `${res.date_string}-${res.opens_at}-${res.closes_at}`,
            value: `${res.id}`,
            date: `${res.date}`,
            available_seats: Number(res.available_seats)
          };
        });
        this.setState({
          options: [...this.state.options]
        });
      } else {
        targetOption.loading = false;
      }
    }, 3000);
    targetOption.loading = false;
  };

  // validateForm = () => {
  //   const { forms } = this.state;
  //   let a = forms.map((res) => res.filter((res) => (res.name || res.room) == '' ))
  // }

  render() {
    const messageSuccess = <IntlMessages id="alacarte.success" />;
    const messageError = <IntlMessages id="user.passwordChangeError" />;
    const inputRequired = <IntlMessages id="alacarte.input_required" />;
    let CreateFormView;
    let CreateRequestView;
    let Loading;
    let ErrorPage;
    let SuccessPage;
    const { messages } = this.props.intl;

    const hotel_id = this.props.hotelConfig.hotelId;

    let mainCourseItems;
    let mainCourseItemsMainCourses;
    let mainCourseItemsOptions;
    let mainCourseDisabledOrActive;
    if (this.props.alacarteApp.getRestaurants.length > 0 && this.state.selectedOptions.length > 1) {
      mainCourseItems = this.props.alacarteApp.getRestaurants.filter((res, id) => res.id == this.state.selectedOptions[0].value);
      mainCourseDisabledOrActive = mainCourseItems[0].config.main_course_selection_required;
      if (mainCourseItems.length > 0) {
        mainCourseItemsMainCourses = mainCourseItems[0].menu.filter((res, id) => res.is_main_course == ("1" || 1 || true || "true"));
        if (mainCourseItemsMainCourses.length > 0) {
          mainCourseItemsOptions = mainCourseItemsMainCourses[0].items.map(result => {
            return (
              <Option key={result.id} value={result.id} name={result.title}>
                {result.title}
              </Option>
            );
          });
        }
      }
    }

    const adultAndChildCounts = [];
    let adultCounts = 0;
    const counts = this.state.forms.map((res, index) => {
      if (res.is_children == false) {
        adultCounts = index + 1;
        return adultAndChildCounts.push(adultCounts);
      }
      return adultAndChildCounts.push(index - adultCounts + 1);
    });

    if (this.state.formView === true && this.state.createRequest === false) {
      CreateRequestView = (
        <div>
          <ModalBody>
            {this.state.showInputNameAndRoomsLength === true ? (
              <div>
                {" "}
                <Alert description={inputRequired} type="error" showIcon />
              </div>
            ) : (
              ""
            )}

            <Fragment>
              <div className="mt-2 mb-2">
                <Form>
                  {this.state.forms.map((res, index) => {
                    // let nameID = `${index}`;
                    // let roomNumberID = `${index}`;
                    // let mainCourseID = `${index}`;
                    return (
                      <div key={`forms${index}`}>
                        {res.is_children === false ? (
                          <p>
                            <IntlMessages id="alacarte.adult" /> - {`${adultAndChildCounts[index]}`}
                          </p>
                        ) : (
                          <p>
                            <IntlMessages id="alacarte.child" /> - {`${adultAndChildCounts[index]}`}
                          </p>
                        )}
                        <Card className="mb-4 mt-4">
                          <CardBody style={{ backgroundColor: "whitesmoke" }}>
                            <FormGroup>
                              <label>
                                {/* <IntlMessages id='alacarte.name' /> */}
                                <span style={{ color: "red" }}>*</span> <IntlMessages id="alacarte.name" />:
                              </label>
                              <Input
                                name="name"
                                //   data-id={`${index}name`}
                                placeholder={messages["alacarte.name"]}
                                onChange={e => this.handleChangeForms(e, index)}
                                value={this.state.forms[index].name}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label className="w-40">
                                {/* <IntlMessages id="'alacarte.room_number'" /> */} <span style={{ color: "red" }}>*</span>{" "}
                                <IntlMessages id="alacarte.room_number" />:
                              </label>
                              <Input
                                type="number"
                                min="0"
                                name="room_number"
                                //   data-id={`${index}room_number`}
                                placeholder={messages["alacarte.room_number"]}
                                onChange={e => this.handleChangeForms(e, index)}
                                value={this.state.forms[index].room_number}
                                className="w-60"
                              />
                            </FormGroup>
                            <FormGroup>
                              <label className="w-40">
                                {mainCourseDisabledOrActive == true || mainCourseDisabledOrActive == "true" ? (
                                  <span style={{ color: "red" }}>*</span>
                                ) : (
                                  ""
                                )}{" "}
                                <IntlMessages id="alacarte.main_course" />:
                              </label>
                              <Select
                                // showSearch
                                placeholder={messages["forms.please_select"]}
                                disabled={!mainCourseDisabledOrActive}
                                style={{ width: 200 }}
                                optionFilterProp="children"
                                onChange={(e, name) => this.handleChangeMainCourse(e, index, name)}
                                className="w-60"

                                // onSelect={this.route}
                                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                              >
                                {mainCourseItemsOptions}
                              </Select>
                            </FormGroup>
                            <FormGroup>
                              <label>
                                <span style={{ color: "red" }}>*</span> <IntlMessages id="alacarte.notes" />:
                              </label>
                              <TextArea
                                rows={4}
                                name="notes"
                                placeholder={messages["alacarte.notes"]}
                                onChange={e => this.handleChangeForms(e, index)}
                                value={this.state.forms[index].notes}
                              />
                            </FormGroup>
                          </CardBody>
                        </Card>
                        {/* <div className="mb-2 mt-2" id={index} style={{ backgroundColor: 'whitesmoke' }}> */}

                        <hr />
                        {/* </div> */}
                      </div>
                    );
                  })}
                </Form>
              </div>
            </Fragment>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" onClick={() => this.createRequest(hotel_id, this.state.forms)}>
              {/* <IntlMessages id="user.update" /> */} <IntlMessages id="alacarte.create_request" />
            </Button>

            <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
              <IntlMessages id="user.cancel" />
            </Button>
          </ModalFooter>
        </div>
      );
    }
    if (this.state.formView === false && this.state.createRequest === false) {
      CreateFormView = (
        <div>
          <ModalBody>
            <div className="mb-3">
              {this.state.showFormPeopleAndTimeSlotRequired === true ? (
                <div>
                  {" "}
                  <Alert description={inputRequired} type="error" showIcon />
                </div>
              ) : (
                ""
              )}
            </div>

            <Fragment>
              <Form>
                <FormGroup>
                  <label>
                    <span style={{ color: "red" }}>*</span> <IntlMessages id="alacarte.select_restaurant_and_slot" />:
                  </label>{" "}
                  <Cascader
                    placeholder={messages["forms.please_select"]}
                    options={this.state.optionsProps}
                    loadData={this.loadData}
                    onChange={this.onChange}
                    changeOnSelect
                    className="w-100 mb-2"
                  />
                </FormGroup>
                <FormGroup>
                  <div className="w-100 d-flex">
                    <div className="w-30">
                      <label>
                        <IntlMessages id="alacarte.available_seats" />:
                      </label>
                    </div>
                    <div className="w-60">
                      <h4>
                        <Badge color="primary" pill>
                          {this.state.selectedOptions && this.state.selectedOptions.length == 2 ? (
                            this.state.selectedOptions[1].available_seats
                          ) : (
                            <IntlMessages id="alacarte.info_available_seats" />
                          )}
                        </Badge>
                      </h4>
                    </div>
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="w-30">
                    <span style={{ color: "red" }}>*</span> <IntlMessages id="alacarte.people_count" />:
                  </label>{" "}
                  <InputNumber
                    size="large"
                    name="peopleCount"
                    min={1}
                    max={
                      this.state.selectedOptions && this.state.selectedOptions.length == 2
                        ? this.state.selectedOptions[1].available_seats - this.state.childrenCount
                        : 10
                    }
                    value={this.state.peopleCount}
                    placeholder={messages["alacarte.people_count"]}
                    // defaultValue={1}
                    onChange={e => this.handleChangePeopleCount(e)}
                    disabled={!(this.state.selectedOptions && this.state.selectedOptions.length == 2)}
                  />
                </FormGroup>
                <FormGroup>
                  <label className="w-30">
                    {" "}
                    <IntlMessages id="alacarte.child_count" />:
                  </label>{" "}
                  <InputNumber
                    size="large"
                    name="childrenCount"
                    min={0}
                    max={
                      this.state.selectedOptions && this.state.selectedOptions.length == 2
                        ? this.state.selectedOptions[1].available_seats - this.state.peopleCount
                        : 10
                    }
                    value={this.state.childrenCount}
                    placeholder={messages["alacarte.child_count"]}
                    // defaultValue={0}
                    onChange={e => this.handleChangeChildCount(e)}
                    disabled={!(this.state.selectedOptions && this.state.selectedOptions.length == 2)}
                  />
                </FormGroup>
              </Form>
            </Fragment>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              type="submit"
              // disabled={
              //   this.state.disabledButton.selectedOptions === true && this.state.disabledButton.peopleCount === true
              //     ? false
              //     : true
              // }
              onClick={() => this.createForm()}
            >
              <IntlMessages id="alacarte.create_request" />
            </Button>

            <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
              <IntlMessages id="user.cancel" />
            </Button>
          </ModalFooter>
        </div>
      );
    }
    if (this.props.alacarteApp.createAlacarteRequestLoading === true && this.state.formView === true && this.state.createRequest === true) {
      Loading = (
        <div>
          <ModalBody>
            <div className="loading" />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
              <IntlMessages id="user.cancel" />
            </Button>
          </ModalFooter>
        </div>
      );
    }
    if (this.props.alacarteApp.createAlacarteRequestError !== "" && this.state.formView === true && this.state.createRequest === true) {
      ErrorPage = (
        <div>
          <ModalBody>
            <div>
              {" "}
              <Alert description={messageError} type="error" showIcon />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
              <IntlMessages id="user.close" />
            </Button>
          </ModalFooter>
        </div>
      );
    }
    if (
      Object.keys(this.props.alacarteApp.createAlacarteRequest).length > 0 &&
      this.props.alacarteApp.createAlacarteRequestLoading === false &&
      this.state.formView === true &&
      this.state.createRequest === true
    ) {
      SuccessPage = (
        <div>
          <ModalBody>
            <div>
              {" "}
              <Alert description={messageSuccess} type="success" showIcon />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
              <IntlMessages id="user.close" />
            </Button>
          </ModalFooter>
        </div>
      );
    }

    return (
      <div>
        <Modal isOpen={this.props.modal}>
          <ModalHeader>
            <IntlMessages id="alacarte.newRequest" />
          </ModalHeader>
          {CreateFormView}
          {CreateRequestView}
          {Loading}
          {ErrorPage}
          {SuccessPage}
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ alacarteApp, settings, auth }) => {
  const { locale, hotelConfig } = settings;
  const { authData } = auth;
  const { getReservationOptions } = alacarteApp;
  return { alacarteApp, locale, hotelConfig, getReservationOptions, authData };
};

export default injectIntl(
  connect(
    mapStateToProps,
    {
      getRequestRestaurant,
      updateRestaurantConfig,
      getSeatsAndSlotsRestaurant,
      createAlacarteRequest
    }
  )(AlacarteCreateRequest)
);
